import axios from "axios";
import { attachSentryResponseInterceptor } from "./sentryAxiosInterceptor";

//TYPES
import { AuthData } from "../types/types";

//AXIOS INSTANCE

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL_AUTH,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const localAuth = localStorage.getItem("allaria-auth");

    const parsedLocalAuth: AuthData | null =
      (localAuth && JSON.parse(localAuth)) ?? null;

    const token = parsedLocalAuth?.access_token;

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
attachSentryResponseInterceptor(axiosInstance);

export const getAllariaMasRedirectUrl = async () => {
  const response = await axiosInstance.post(`/user/on-behalf-of/allaria+`, {});
  return response.data as Promise<{
    url: string;
  }>;
};

export const getAllariaEscoRedirectUrl = async () => {
  const response = await axiosInstance.post(`/user/on-behalf-of/esco`, {});
  return response.data as Promise<{
    url: string;
  }>;
};

export const getAllariaDmaRedirectUrl = async () => {
  const response = await axiosInstance.post(`/user/on-behalf-of/dma-web`, {});
  return response.data as Promise<{
    url: string;
  }>;
};
